import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-lg font-medium md:text-base" }
const _hoisted_3 = ["onClick"]

import { setUserLanguage } from '@/api/settings'
import { getUser } from '@/api/user'
import BaseDropdown from '@/components/base/BaseDropdown.vue'
import { useLanguageStore } from '@/store/language'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'LocaleSwitcher'
},
  __name: 'LocaleSwitcher',
  setup(__props) {



const languageStore = useLanguageStore()
const store = useStore()
const { availableLocales } = useI18n()

const { language } = storeToRefs(languageStore)

const isAdmin = computed<boolean>(() => store.getters['companyData/isAdmin'])

const isLoggedIn = computed<boolean>(() => store.getters['auth/isLoggedIn'])

const switchLanguage = async (locale: Locale): Promise<void> => {
  await languageStore.changeLanguage(locale)
  if (isLoggedIn.value && !isAdmin.value) {
    await setUserLanguage(locale)
    const user = await getUser()
    await store.dispatch('companyData/setUserCompanyDetails', user)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createBlock(BaseDropdown, {
    id: "locale-switcher",
    align: "center"
  }, {
    button: _withCtx(({ toggle }) => [
      _createElementVNode("button", {
        id: "locale-switcher",
        type: "button",
        class: "flex items-center fill-current font-medium uppercase outline-hidden",
        onClick: toggle
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(language)), 1),
        _createVNode(_component_VIcon, {
          icon: "$chevron-down",
          size: "1rem"
        })
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableLocales), (locale) => {
        return (_openBlock(), _createElementBlock("button", {
          key: locale,
          type: "button",
          class: _normalizeClass(["w-full p-2 text-lg uppercase transition duration-150 ease-in-out hover:bg-secondary-100 md:px-4 md:text-sm", { 'active-lang': locale === _unref(language) }]),
          onClick: ($event: any) => (switchLanguage(locale))
        }, _toDisplayString(locale), 11, _hoisted_3))
      }), 128))
    ]),
    _: 1
  }))
}
}

})